module.exports = __webpack_public_path__ + "static/media/db_anim.5c818283.gif";